import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import ExpertiseSection from '../components/ExpertiseSection';
import PortfolioSection from '../components/PortfolioSection';
import TestimonialsSection from '../components/TestimonialsSection';
import WhySection from '../components/WhySection';
import OffersSection from '../components/OffersSection';
import ResourcesPromoSection from '../components/ResourcesPromoSection';
import BlogSection from '../components/BlogSection';
import NewsletterSection from '../components/NewsletterSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import { ScrollProgress } from '../components/ScrollAnimations';

const HomePage = () => {
  return (
    <div className="bg-black min-h-screen">
      <ScrollProgress />
      <Header />
      <main>
        <HeroSection />
        <ExpertiseSection />
        <PortfolioSection />
        <TestimonialsSection />
        <WhySection />
        <OffersSection />
        <ResourcesPromoSection variant="full" />
        <BlogSection />
        <NewsletterSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
